"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagLS = function FlagLS(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.18,28.11,34.54,29l-.69.32L19.35,11c3-6.48,4.74-15.32,4.74-19.34,0-6.61-4.33-12.11-10-13.27a2.42,2.42,0,0,0-2.24-1.47,2.44,2.44,0,0,0-2.24,1.47C3.87-20.5-.47-15-.47-8.39c0,4,1.77,12.86,4.75,19.34l-14.5,18.32-.69-.32-1.64-.84-6.13,12L-17,41a63.93,63.93,0,0,0,28.85,6.5A64,64,0,0,0,40.67,41l1.64-.84ZM21.64-8.39a53.42,53.42,0,0,1-3.17,15c-.27.76-.55,1.48-.83,2.16L15.5,6.09V-3.48h3.68L14.27-8.39V-19.08c4.23,1.23,7.37,5.55,7.37,10.69ZM5.15,6.63A53.69,53.69,0,0,1,2-8.39c0-5.14,3.13-9.46,7.36-10.7v10.7L4.44-3.48H8.13V6.09L6,8.79q-.44-1-.84-2.16ZM-11.37,33.9l.51,2.06-1.8.49Zm-2.14,4.69,3.08-.84.57,2.33c-1.25-.46-2.47-.94-3.65-1.49Zm4.67-4.69a45.55,45.55,0,0,0,4.36,1.48L-4,36.74l-3.87,1ZM-7.11,41l-.37-1.53,4-1,1.25,3.81C-3.88,42-5.52,41.52-7.11,41Zm5.45-4.9c1.55.36,3.12.67,4.72.9l.67,1.2L-.54,39.55Zm2.2,6.72L0,41.3l4.6-1.44L6.73,43.6q-3.15-.24-6.19-.76Zm5.54-5.45c1.89.18,3.81.27,5.73.27l1.23,0,.51.79-5.66,2.2Zm5.73,6.41c-.73,0-1.45,0-2.17,0l-.85-1.51L14.58,40l2.35,3.59c-1.69.13-3.39.21-5.12.21Zm4.08-6.29a57.32,57.32,0,0,0,5.76-.67l.55.71-4.49,2.76Zm3.8,5.82-1-1.48L23.34,39l2.57,3.29a62.53,62.53,0,0,1-6.22,1Zm4.67-7c1.61-.35,3.18-.75,4.71-1.23l.57.74L26.38,38.9Zm4.18,5.34-1-1.31,3.25-3.06L33,40.24c-1.47.53-3,1-4.5,1.43Zm3-7.41c1-.38,2.05-.79,3-1.23L35,34l-1.57,2.8Zm3.91,5.06-.74-1L36,36l1.3,2.56c-.63.29-1.27.55-1.91.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagLS;
exports["default"] = _default;